import React from "react";
/* Import Boostrap */
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import VisibilitySensor from 'react-visibility-sensor';

import CoverHeader from './cover-header';
import Heading1 from '../titles/Heading1';
import Heading2 from '../titles/Heading2';
import Button from '../buttons/button';


class CoverHeaderButton extends React.Component {

    constructor() {
        super();
        this.state = {
            animated : false,
            animationClasses : ['']
        };
        this.headerVisible = this.headerVisible.bind(this);
    }
    headerVisible(isVisible) {
        if (isVisible) {
            if (!this.state.animated) {
                var classes = this.state.animationClasses;
                classes.push('animate-box');
                classes.push('fadeInUp');
                classes.push('animated-fast');
                this.setState({ animated: true, animationClasses: classes});
            }
        }
    };

    render () {
        //console.log('CoverHeaderButton renders more than once? '+this.props.backgroundImages);
        return (
            <VisibilitySensor partialVisibility={ true } onChange={ this.headerVisible }>
                <CoverHeader imageUrl={ this.props.backgroundImages }>
                    <Row>
                        <Col className="text-left" md={12} >
                            <div className="display-t">
                                <div className="display-tc">
                                    <Heading1 wait={100} title = { this.props.headerTitle } className={ this.state.animationClasses.join(' ')} />
                                    <Heading2 wait={300} title = { this.props.headerSubTitle } className={ this.state.animationClasses.join(' ')} />
                                    <Button wait={500} buttonName={ this.props.buttonName } buttonTo={ "/"+this.props.buttonTo } buttonClass={ this.props.buttonClass } className={ this.state.animationClasses.join(' ')} />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </CoverHeader>
            </VisibilitySensor>
        );
    };
};

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(CoverHeaderButton);



// WEBPACK FOOTER //
// ./src/components/header/cover-header-button.jsx